'use client';

import { Input } from 'components';
import dynamic from 'next/dynamic';
import React from 'react';
import { Icon } from 'components/Icon';
// import { Suspense } from 'react';
import { Card } from 'components';
import { useHomeController } from 'controllers/useHomeController';
// import { Pagination } from 'app/components/Pagination';

// Componentes dinâmicos
const ReactSelect = dynamic(() => import('react-select'), { ssr: false });

const Content: React.FC<any> = ({ searchParams }) => {
  const {
    // Estados e handlers necessários
    inputRef,
    inputValue,
    handleInputChange,
    handleKeyDown,
    categories,
    currentCategory,
    handleCategorySelect,
    setIsOpen,
    clearSearch,
    campaigns,
  } = useHomeController(searchParams);

  const categoryOptions = categories.map((cat) => ({
    value: cat.id,
    label: cat.title,
  }));

  return (
    <div className='flex flex-1 flex-col'>
      {/* Seção de Filtros */}
      <div className='bg-gray-8 px-6 mobile:px-4'>
        <div className='flex w-full flex-col items-center pt-10'>
          <div className='mb-16 mt-10 flex w-full max-w-[900px] items-center gap-4 md:items-end'>
            <Input
              inputRef={inputRef}
              value={inputValue}
              onChange={handleInputChange}
              handleKeyDown={handleKeyDown}
              label='Buscar campanhas'
              sx={{
                container: 'border-[0.1rem] border-gray-3 rounded-full',
                label: 'text-white text-medium-regular font-normal pb-1',
              }}
              clearable
            />

            <button
              onClick={() => setIsOpen(true)}
              className='relative flex items-center justify-center pt-6 md:hidden'
            >
              <Icon
                icon='filter1'
                size={24}
                color='white'
                className='cursor-pointer'
              />

              {(inputValue.trim().length > 0 || currentCategory !== null) && (
                <span className='bg-red-500 absolute -right-2 top-[1rem] flex min-h-3 min-w-3 items-center justify-center rounded-full bg-brand-pure text-[8px] text-white'>
                  {inputValue.trim().length > 0 && currentCategory !== null
                    ? '2'
                    : '1'}
                </span>
              )}
            </button>

            {(inputValue.trim().length > 0 || currentCategory !== null) && (
              <button
                type='button'
                aria-label='Limpar filtros'
                className='text-sm hidden items-center gap-2 whitespace-nowrap font-medium text-white underline md:flex'
                onClick={clearSearch}
              >
                <span className='hidden md:block'>Limpar</span>
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  className='block h-5 w-5 md:hidden'
                  fill='none'
                  viewBox='0 0 24 24'
                  stroke='currentColor'
                  strokeWidth='2'
                >
                  <path
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    d='M6 18L18 6M6 6l12 12'
                  />
                </svg>
              </button>
            )}
          </div>
        </div>
      </div>

      {/* Título e Lista de Campanhas */}
      <div className='mt-12 flex w-full items-center justify-center px-6 mobile:px-4'>
        <div className='flex w-[1300px] items-center justify-between'>
          <h1>Todas as campanhas</h1>
        </div>
      </div>

      <div className='mb-6 mt-6 grid gap-x-4 gap-y-6 self-center px-6 md:grid-cols-2 lg:grid-cols-3 mobile:grid-cols-1 mobile:place-items-center mobile:px-4 desktop-tight:grid-cols-4'>
        {campaigns?.map((card) => (
          <Card
            key={card.id}
            author={card.user.name}
            slug={card.slug}
            cover={card.cover}
            title={card.title}
            percentage={card.percentage}
            supporters={card.supporters}
            verified={card.verified}
            startDate={card.startDate}
            endDate={card.endDate}
          />
        ))}
      </div>
      {inputValue.trim().length > 0 && !campaigns.length && (
        <div className='flex h-[300px] w-full items-center justify-center'>
          <h1 className='text-[18px] font-semibold text-gray-8'>
            Nenhum resultado encontrado para a busca {inputValue}
          </h1>
        </div>
      )}
      {/* <div className='flex w-full items-center justify-center'>
        <Pagination currentPage={1} totalPages={10} onPageChange={() => {}} />
      </div> */}
    </div>
  );
};

export { Content };
